import type { Lang } from "@/i18n/languages";

export const SEO_DOMAINS: Record<Lang, string> = {
  bg: "elitedentalsolutions.bg",
  en: "elitedentalsolutions.eu",
  de: "elitedentalsolutions.de",
  gr: "elitedentalsolutions.gr",
};

export function buildAbsoluteUrl(lang: Lang, pathname: string): string {
  const domain = SEO_DOMAINS[lang] ?? SEO_DOMAINS.bg;
  const path = pathname?.startsWith("/") ? pathname : `/${pathname || ""}`;
  return `https://${domain}${path}`;
}

